module.exports = __webpack_public_path__ + "static/servicesBgTwo-6204fcf920aa3d1ac9aeb33dc01d7cfc.jpg";